import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { GetTeamsBulkResponse } from './types.tsx';

const TEAMS_BULK_REST_API_URL_V4 = '/gateway/api/v4/teams/withMembers/bulk';

export const getTeams = async (teamIds: string[], siteId: String) =>
	performPostRequest<GetTeamsBulkResponse>(TEAMS_BULK_REST_API_URL_V4, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			teamIds,
			siteId,
		}),
	});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { TeamRecord } from './types';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mockGetTeamsSuccess, mockGetTeamsFailure } from './mocks';
